import {Injectable} from "@angular/core";
import {UserMarketingRulesDb} from "@app/core/user-marketing-rules/infrastructure/user-marketing-rules-db";
import {LargeStorageLocal} from "@app/core/shared/domain/storage/large-storage.local";

@Injectable({
    providedIn: 'root'
})
export class UserMarketingRulesDao {

    private readonly USER_MARKETING_RULES_KEY = 'user-marketing-rules';

    constructor(
        private largeStorageLocal: LargeStorageLocal
    ) {}

    search(): UserMarketingRulesDb | null {
        const userDataString = this.largeStorageLocal.getItem(this.USER_MARKETING_RULES_KEY);
        if (userDataString == null) {
            return null;
        }
        return JSON.parse(userDataString) as UserMarketingRulesDb;
    }

    update(userData: UserMarketingRulesDb): void {
        this.largeStorageLocal.setItem(this.USER_MARKETING_RULES_KEY, JSON.stringify(userData));
    }

}